import { Container, Reveal, Section, SectionHead } from '@nexa/ui';
import { useCopy } from '@/core/i18n';
import { PricingCard } from './PricingCard.tsx';

/**
 * `#pricing` — `template.html:1012`.
 *
 * Đầu section canh GIỮA với `max-52ch` (`:1014`) ⇒ `align="center"`, và `SectionHead` tự đổi cả
 * `max-width` lẫn `mx-auto` theo cách canh, không chỉ `text-center`.
 *
 * `headingSize="h2-compact"`: thiết kế vẽ h2 ở bậc 38px (`:1016`), là bậc RIÊNG từ lô A′ chứ không
 * phải `--text-h2` (40). `leadSize` để mặc định `lead` — cỡ 16px ở `:1017` không bold nên nó mang
 * vai ĐOẠN VĂN, không phải tiêu đề (`reference.md` §4.1: 16px là cỡ duy nhất mang hai vai, phân
 * biệt bằng `font-weight` ≥ 600).
 *
 * `row-gap` ở 1 cột phải ≥ 22px và đó là luật `chốt` có lý do vật lý: badge nhô lên 11px
 * (`:1022`), gap nhỏ hơn thì card trên CHE badge của card dưới. Giữ 3 cột từ `md` — card pricing
 * 2 cột lệch nhìn rất tệ (`reference.md` §2 hàng 11).
 */
export function PricingSection() {
  const copy = useCopy();

  return (
    <Section id="pricing" labelledBy="pricing-head" cv className="nx-cv-pricing">
      <Container>
        <Reveal>
          <SectionHead
            id="pricing-head"
            eyebrow={copy.pricing.eyebrow}
            heading={copy.pricing.heading}
            lead={copy.pricing.lead}
            align="center"
            headingSize="h2-compact"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-[22px] md:grid-cols-3 md:gap-[18px]">
          {copy.pricing.plans.map((plan) => (
            <Reveal key={plan.name} className="h-full">
              <PricingCard {...plan} />
            </Reveal>
          ))}
        </div>
      </Container>
    </Section>
  );
}
